export const StripHtml = (input: string): string => {
	const inputWithHtmlTags = input?.replace(/<\/?[^>]+(>|$)/g, "");

	// https://www.w3schools.com/HTML/html_entities.asp
	// https://stackoverflow.com/questions/657643/how-to-remove-html-special-chars
	return inputWithHtmlTags?.replace(/&#?[a-z0-9]{2,8};/g, "");
};
